
export const shouldRun = (
  rule,
  trigger,
  compOnChange,
) => {
  if (trigger === "onSubmit") return true;

  const ruleOnChange = Array.isArray(rule.validateTrigger)
    ? rule.validateTrigger.includes("onChange")
    : rule.validateTrigger === "onChange";

  return compOnChange || ruleOnChange;
};
